import React, { useReducer } from 'react'

import { initialState, reducer, ProductContext } from './context'

import type { IUpdateProduct } from './model'

export function withProduct(PageComponent: React.FC) {
  return function EnhancedComponent<T>(props: T): JSX.Element {
    const [state, dispatch] = useReducer(reducer, initialState)

    const updateProduct: IUpdateProduct = (sku) => {
      dispatch({ type: 'UPDATE', payload: { sku } })
    }

    return (
      <ProductContext.Provider value={{ ...state, updateProduct }}>
        <PageComponent {...props} />
      </ProductContext.Provider>
    )
  }
}

export default withProduct
